"use client";

import dynamic from "next/dynamic";

import HomeSection from "@/components/home-section";
import OfflineCenterCard from "@/components/card/offline-center";

import useMoengageEventTracker from "@/hooks/use-moengage";

import EVENT_NAME from "@/hooks/use-moengage/event-name.json";
import EVENT_ATTRIBUTE from "@/hooks/use-moengage/event-attribute.json";

const DelhiCenter = dynamic(() => import("./images/delhi.svg"));
// const GuwahatiCenter = dynamic(() => import("./images/guwahati.svg"));
const IndoreCenter = dynamic(() => import("./images/indore.svg"));
const LucknowCenter = dynamic(() => import("./images/lucknow.svg"));
const PatnaCenter = dynamic(() => import("./images/patna.svg"));
const PrayagrajCenter = dynamic(() => import("./images/prayagraj.svg"));

const offlineCenters = [
  {
    name: "Patna",
    image: PatnaCenter,
    link: "https://www.studyiq.com/best-upsc-coaching-in-patna",
  },
  {
    name: "Delhi",
    image: DelhiCenter,
    link: "https://www.studyiq.com/best-upsc-coaching-in-delhi",
  },
  {
    name: "Prayagraj",
    image: PrayagrajCenter,
    link: "https://www.studyiq.com/best-upsc-coaching-in-prayagraj",
  },
  {
    name: "Lucknow",
    image: LucknowCenter,
    link: "https://www.studyiq.com/best-upsc-coaching-in-lucknow",
  },
  // {
  //   name: "Guwahati",
  //   image: GuwahatiCenter,
  //   link: "https://www.studyiq.com/best-upsc-coaching-in-guwahati",
  // },
  {
    name: "Indore",
    image: IndoreCenter,
    link: "https://www.studyiq.com/best-upsc-coaching-in-indore",
  },
];

function OfflineCenters() {
  const trackMoengageEvent = useMoengageEventTracker();

  const handleOnClick = (offlineCenter) => () => {
    trackMoengageEvent(EVENT_NAME.OFFLINE_CENTERS_CHECKED, {
      [EVENT_ATTRIBUTE.LOCATION]: offlineCenter.name,
    });
  };

  return (
    <HomeSection
      title="Offline Centers"
      subtitle={
        <>
          <span>Find our</span>
          <span className="text-primary">Offline Centers</span>
        </>
      }
      className="flex flex-row flex-wrap justify-center gap-y-8 gap-x-4"
    >
      {offlineCenters.map((offlineCenter) => (
        <OfflineCenterCard
          key={offlineCenter.name}
          name={offlineCenter.name}
          image={offlineCenter.image}
          onClick={handleOnClick(offlineCenter)}
          href={offlineCenter.link}
          className="basis-[calc(50%_-_0.5rem)] shrink-0 grow-0 md:basis-[calc(33.333%_-_0.6667rem)]"
        />
      ))}
    </HomeSection>
  );
}

export default OfflineCenters;
